/**
 * Main JavaScript entry point for Frank Rettig Beratung theme
 */

console.log('Frank Rettig Beratung - Theme loaded');
